import { render, staticRenderFns } from "./InternalHeader.vue?vue&type=template&id=2da53274&"
import script from "./InternalHeader.vue?vue&type=script&lang=js&"
export * from "./InternalHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports